module.exports = __webpack_public_path__ + "static/img/advantage2.7e5b97e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/advantage2.png
// module id = QeZT
// module chunks = 8